export const colorChart = [
  '#006AA6',
  '#FFCD60',
  '#D96383',
  '#74B49A',
  '#E6964C',
  '#00A8B5',
]

export const OTHER_ID = 'others'
